import { render, staticRenderFns } from "./privacy-dec29.vue?vue&type=template&id=710b35ad&scoped=true"
import script from "./privacy-dec29.vue?vue&type=script&lang=js"
export * from "./privacy-dec29.vue?vue&type=script&lang=js"
import style0 from "./privacy-dec29.vue?vue&type=style&index=0&id=710b35ad&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b35ad",
  null
  
)

export default component.exports